import {
  LANGUAGE,
  TIMEZONE,
  TOGGLE_COLLAPSED_NAV,
} from "../constants/ActionTypes";

export const toggleCollapsedNav = (isNavCollapsed) => {
  return { type: TOGGLE_COLLAPSED_NAV, isNavCollapsed };
};

export const changeUserLanguage = (newLanguage) => {
  return { type: LANGUAGE, newLanguage };
};

export const changeTimezone = (timezone) => {
  return { type: TIMEZONE, timezone };
};
